var initializeChartBlock = function(block){ 
	
	var slidesToShowPerSlide = parseInt(jQuery('.charts-slider').attr('data-per-slide'));
	var slidesTotal = parseInt(jQuery('.charts-slider').attr('data-total'));
	var showDots = slidesTotal > slidesToShowPerSlide ? true : false;

	jQuery('.charts-slider:not(.slick-initialized)', block).slick({
		slide: '.chart',
		slidesToShow: slidesToShowPerSlide,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: showDots,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: false,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		centerMode: false,
		responsive: [
		{
		  breakpoint: 680,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
		]
	});
	
	const tippyInstances = tippy('.wp-block-chart [data-tippy-content]');
	
	const singleton = tippy.createSingleton(tippyInstances, {
		allowHTML: true,
		placement: 'right',
		offset: [0,0],
		theme: 'thorn',
		moveTransition: 'transform 0.2s ease-out',
	});
	
	//const singleton = createSingleton(tippyInstances, {delay: 1000});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-chart').each(function(){
		initializeChartBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=chart', initializeChartBlock);
